module.exports = __webpack_public_path__ + "static/media/bulk_master_truck.37489ff9.csv";